import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, Input
} from 'reactstrap';
import {toast} from 'react-toastify';

import loadingGIF from "../../public/assets/images/loading.gif";
import ErrorMsg from "../common/ErrorMsg";
import ConfirmModal from "../common/ConfirmModal";
import HolidayForm from "../pto/HolidayForm";
import {WEEK_DAYS} from "../pto/Constants";


const EMPTY_HOLIDAY = {
    id: '',
    name: '',
    default_date: '01-01',
    has_fixed_date: true,
    week_no: 1,
    day: 1,
    month: 1,
    location_list: []
};

export default class DefaultHoliday extends Component {
    state = {
        showAddButton: true,
        confirmationModalData: {},
        holidayOptions: [],
        isOpenHolidayForm: false,
        selectedHoliday: {...EMPTY_HOLIDAY},
        isLoading: false
    }

    componentDidMount = () => {
        let {locationList} = this.props;
        console.log(locationList, this.props)
        let updatedLocationList = locationList.map(location => {
            if (location.id === Number(this.props.agencyLocation)) {
                return {...location, checked: true};
            } else {
                return {...location, checked: false};
            }
        });
        this.setState({locationList: updatedLocationList});
        this.getSettings();
        return;
    }

    componentDidUpdate = (prevProps) => {
        const {settings} = this.props.pto;
        if (settings.id !== prevProps.pto.settings.id) {
            this.getSettings();
            
         }
    }
    getSettings = async () => {
        this.setState({isLoading: true});
        
        try {
            const {year} = this.props.pto;
            const result = await this.props.ptoSetting(
                this.props.agencyLocation, {}, year, "GET"
            );
            console.log(result)
            if (result) {
                const {settings} = this.props.pto;
                this.props.getAssignedHolidayList(settings.id)
                // this.setSettingObjects();
            }
        } catch(error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        this.getHolidays();
        this.setState({isLoading: false});
    }

    getHolidays = async () => {
        this.setState({isLoading: true});
        try {
            const result = await this.props.getHolidayList(this.props.agencyLocation);
            if (result) {
                this.setHolidayOptions();
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />);
        }
        this.setState({isLoading: false});
    }

    // Compare KPI for sorting
    compareDate = (a, b) => {
        let month1 = Number(a.default_date.split('-')[0]);
        let date1 = Number(a.default_date.split('-')[1]);
        let month2 = Number(b.default_date.split('-')[0]);
        let date2 = Number(b.default_date.split('-')[1]);
        if (month1 < month2) {
            return -1;
        }
        if (month1 > month2) {
            return 1;
        }
        if (date1 < date2) {
            return -1;
        }
        if (date1 > date2) {
            return 1;
        }
        return 0;
    };

    setHolidayOptions = () => {
        const {year} = this.props;
        console.log(this.props)
        const {assignedHolidayList, holidayList} = this.props.pto;
        let assignedObj = {};
        assignedHolidayList.map(assignedHoliday => {
            assignedObj[assignedHoliday.holiday] = assignedHoliday
        });

        let sortedHolidayList = [...holidayList];
        sortedHolidayList.sort(this.compareDate);
        
        // make a list of holidays with saved/default values  // permission={this.auth.permission}
                        // refre
        let holidayOptions = sortedHolidayList.map(holiday => {
            const assignedHoliday = assignedObj[holiday.id];
            const spltedDate = holiday.default_date.split('-');
            const initialDate = moment().year(year).month(
                Number(spltedDate[0])-1
            ).date(Number(spltedDate[1]));
            const occasionDate = assignedHoliday && assignedHoliday.occasion_date ? 
                moment(assignedHoliday.occasion_date, "MM/DD/YYYY") : initialDate;
            let dow = moment(occasionDate).day();
            let alternateDate = assignedHoliday && assignedHoliday.alternate_date ? 
                moment(assignedHoliday.alternate_date, "MM/DD/YYYY") : null
            
            alternateDate =  alternateDate ? alternateDate : (dow === 0 || dow === 6) ?
                moment(occasionDate).add(1, 'week').isoWeekday(1) : null;
            
            return {
                id:  assignedHoliday? assignedHoliday.id : null,
                name: holiday.name,
                holiday: assignedHoliday ? assignedHoliday.holiday : holiday.id,
                pto_setting: this.props.pto.settings.id,
                active: assignedHoliday ? assignedHoliday.active : false,
                default_date: holiday.default_date,
                occasion_date: occasionDate,
                alternate_date: alternateDate,
                has_fixed_date: holiday.has_fixed_date,
                week_no: holiday.week_no,
                day: holiday.day,
                month: holiday.month, 
                paid_ft: assignedHoliday ? assignedHoliday.paid_ft : true,
                paid_pt: assignedHoliday ? assignedHoliday.paid_pt : true
            }
        });
        this.setState({holidayOptions});
    }

    openDeleteConfirmation = (holidayObj) => {
        let showConfirmModal = true, size="sm", hide=this.closeConfirmationModal;
        let msgTitle = "Confirmation!";
        let msgBody = <p>Are you sure, you want to delete this holiday?</p>
        let buttons = [
            {
                className: "btn btn-danger",
                onClick: () => this.deleteHoliday(holidayObj),
                label: "Yes"
            },
            {
                className: "btn btn-default",
                onClick: this.closeConfirmationModal,
                label: "No"
            }
        ];
        this.setState({
            confirmationModalData: {
                showConfirmModal, size, hide, msgTitle, msgBody, buttons
            }
        });
        return false;
    }

    deleteHoliday = async (holidayObj) => {
        try {
            let result;
            if (holidayObj.holiday) {
                result = await this.props.deleteHoliday(holidayObj.holiday);
            } 
            if (result) {
                toast.success("Deleted Successsfully.");
                this.setHolidayOptions();
                // this.props.refreshPTOInfos();
            }
        } catch(error) {
            toast.error(<ErrorMsg errors={error} />);
        }
    }

    closeConfirmationModal = () => {
        this.setState({
            confirmationModalData: {
                ...this.state.confirmationModalData, showConfirmModal: false
            }
        });
    }

    handleDateChangeRaw = (event) => {
		event.preventDefault();
	};

	handleDateChange = (date, holiday, name) => {
        const {holidayOptions} = this.state;
        let newHolidayOptions = holidayOptions.map(holidayObj => {
            if (holidayObj.holiday === holiday.holiday) {
                if (name === "occasion_date") {
                    let dow = moment(date).day();
                    
                    const alternateDate = dow === 0 || dow === 6 ? 
                        moment(date).add(1, 'week').isoWeekday(1) : null;

                    return {
                        ...holidayObj,
                        [name]: moment(date),
                        alternate_date: alternateDate
                    };

                } else {
                    let dow = moment(date).day();
                    if (dow === 0 || dow === 6) {
                        toast.error("Alternate Date must be a weekday.");
                        return {...holidayObj};
                    }
                    return {
                        ...holidayObj,
                        [name]: moment(date)
                    };
                }
            }
            return {...holidayObj};
        });
        this.setState({holidayOptions: newHolidayOptions});
    };

   

    saveHoliday = async (holiday, showMsg=false) => {
        try {
            let updatedHolidayObj = {
                ...holiday,
                occasion_date: moment(holiday.occasion_date).format("YYYY-MM-DD"),
                alternate_date: holiday.alternate_date ? 
                    moment(holiday.alternate_date).format("YYYY-MM-DD") 
                    : null
            }
            let result = false;
            if (holiday.id) {
                result = await this.props.updateHolidayAssignment(updatedHolidayObj);
            } else {
                const {settings} = this.props.pto;
                result = await this.props.CreateHolidayAssignment(
                    settings.id, updatedHolidayObj
                );
            }
            if(result) {
                this.setHolidayOptions();
                if (showMsg) {
                    toast.success("Saved Successfully.");
                }
                // this.props.refreshPTOInfos();
            }
        } catch (error) {
            if (!showMsg) {
                const {holidayOptions} = this.state;
                const updatedHolidayObj = {
                    ...holiday,
                    active: !holiday.active,
                };
                let newHolidayOptions = holidayOptions.map(holidayObj => {
                    if (holidayObj.holiday === holiday.holiday) {
                        return updatedHolidayObj;
                    }
                    return {...holidayObj};
                });
                this.setState({holidayOptions: newHolidayOptions});
            }
            toast.error(<ErrorMsg errors={error} />);
        }
    }
    
    renderHolidays = () => {
        let holidayListRows = [];
        const {year} = this.props;
        const {holidayOptions} = this.state;
        const currentYear = moment().year();
        
        holidayOptions.map((holiday, index) => {
            const dow = holiday.occasion_date.day();
            // console.log(holiday.alternate_date)
            holidayListRows.push(
                <tr key={index}>
                    {/* <td className="text-center align-middle" style={{width: "80px"}}>
                        <Input type="checkbox" className="my-0 position-relative cursor-pointer" 
                            value={holiday.active} 
                            checked={holiday.active} 
                            onChange={(e) => this.handleCheckBoxChange(e, holiday)} 
                            name="active"
                            disabled={currentYear > year}
                        />
                    </td>
                    <td className="text-center align-middle" style={{width: "80px"}}>
                        <Input type="checkbox" className="my-0 position-relative cursor-pointer" 
                            value={holiday.paid_ft} 
                            checked={holiday.paid_ft} 
                            onChange={(e) => this.handleCheckBoxChange(e, holiday)} 
                            name="paid_ft"
                            disabled={currentYear > year}
                        />  
                    </td>
                    <td className="text-center align-middle" style={{width: "80px"}}>
                        <Input type="checkbox" className="my-0 position-relative cursor-pointer" 
                            value={holiday.paid_pt} 
                            checked={holiday.paid_pt} 
                            onChange={(e) => this.handleCheckBoxChange(e, holiday)} 
                            name="paid_pt"
                            disabled={currentYear > year}
                        />
                    </td> */}
                    <td className="align-middle">{holiday.name}</td>
                    <td className="align-middle" style={{width: "130px"}}>
                        <div className="div-datepicker">
                            <DatePicker
                                selected={holiday.occasion_date}
                                onChangeRaw={this.handleDateChangeRaw}
                                onChange={(date) => 
                                    this.handleDateChange(date, holiday, 'occasion_date')
                                }
                                fixedHeight dateFormat="MM/DD/YYYY"
                                showMonthDropdown showYearDropdown
                                dropdownMode="select" 
                                className="form-control form-control-sm"
                                minDate={moment().year(year).month(0).date(1)}
                                maxDate={moment().year(year).month(11).date(31)}
                                autoComplete="off" 
                                list="autocompleteOff"
                                disabled={currentYear > year}
                                title={holiday.occasion_date ? 
                                    WEEK_DAYS[dow] : ''
                                }
                            />
                        </div>
                    </td>
                    <td className="align-middle" style={{width: "130px"}}>
                        <div className="div-datepicker">
                            <DatePicker
                                selected={holiday.alternate_date}
                                onChangeRaw={this.handleDateChangeRaw}
                                onChange={(date) => 
                                    this.handleDateChange(date, holiday, 'alternate_date')
                                }
                                fixedHeight dateFormat="MM/DD/YYYY"
                                showMonthDropdown showYearDropdown
                                dropdownMode="select" 
                                className="form-control form-control-sm"
                                minDate={moment().year(year).month(0).date(1)}
                                maxDate={moment().year(year).month(11).date(31)}
                                autoComplete="off" 
                                list="autocompleteOff"
                                disabled={(dow !== 6 && dow !== 0) || currentYear > year}
                                // title={holiday.alternate_date ? 
                                //     WEEK_DAYS[holiday.alternate_date.day()] : ''
                                // }
                            />
                        </div>
                    </td>
                    <td className="align-middle text-center cursor-pointer" 
                        style={{width: "120px"}}
                    >
                        {year >= currentYear && this.props.permission.can_edit &&
                            <i className="fa fa-save pr-3 text-success"
                                onClick={() => this.saveHoliday(holiday, true)}
                                title="Save changes"
                            ></i>
                        }
                        {this.props.permission.can_edit &&
                            <i className="fa fa-pencil pr-3 text-warning" 
                                onClick={() => this.openHolidayForm(holiday)}
                                title="Edit Holiday"
                            ></i>
                        }
                        {this.props.permission.can_delete &&
                            <i className="fa fa-trash text-danger"
                                onClick={() => this.openDeleteConfirmation(holiday)}
                                title="Delete Holiday"
                            ></i>
                        }
                    </td>
                </tr>
            );
            return true;
        });

        return holidayListRows;
    }

    openHolidayForm = (holiday) => {
        if (holiday) {
            this.setState({
                selectedHoliday: {
                    ...holiday,
                    id: holiday.holiday,
                    name: holiday.name,
                    default_date: holiday.default_date
                }, 
                isOpenHolidayForm: true
            });
        } else {
            this.setState({
                selectedHoliday: {...EMPTY_HOLIDAY}, 
                isOpenHolidayForm: true
            });
        }
    }

    closeHolidayForm = () => {
        this.setState({
            selectedHoliday: {...EMPTY_HOLIDAY}, 
            isOpenHolidayForm: false
        });
        this.setHolidayOptions();
    }

    render() {
        const {
            confirmationModalData, isOpenHolidayForm, selectedHoliday, isLoading
        } = this.state;

        const {permission} = this.props;

        return (
            <Modal isOpen={this.props.modal} size="lg" toggle={this.props.toggleModal}>
                <ModalHeader toggle={this.props.toggleModal}>
                    Holidays
                </ModalHeader>
                <ModalBody>
                    {permission.can_view &&
                        <Table hover striped size="sm">
                            <thead>
                                <tr>
                                    {/* <th className="text-center">Assign</th>
                                    <th className="text-center">Paid FT</th>
                                    <th className="text-center">Paid PT</th> */}
                                    <th>Holiday</th>
                                    <th>Date</th>
                                    <th>Alternate Date</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderHolidays()}
                            </tbody>
                        </Table>
                    }
                    {isLoading && 
                        <p className="loading-gif">
                            <img src={loadingGIF} alt="Loading..." 
                                width="32" height="32"
                            />
                        </p>
                    }
                </ModalBody>
                <ModalFooter>
                    {permission.can_add &&
                        <Button color="info" className="mr-3"
                            onClick={() => this.openHolidayForm("")}
                        >Add Holiday</Button>
                      }
                    <Button color="secondary" onClick={this.props.toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
                {confirmationModalData.showConfirmModal &&
                    <ConfirmModal {...confirmationModalData} />
                }
                {isOpenHolidayForm  && (permission.can_add || permission.can_edit) && 
                    <HolidayForm {...this.props}
                        modal={isOpenHolidayForm}
                        toggleModal={this.closeHolidayForm} 
                        selectedHoliday={selectedHoliday}
                    />
                }
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/daliyAttendance/DefaultHoliday.js